import AllRoutes from './all.routes'
import store from '../store/index.js'

import AdminAudits from '@/views/admin/audits/AdminAudits.vue'
import AdminRoutes from '@/views/admin/routes/AdminRoutes.vue'
import AdminTma from '@/views/admin/tma/AdminTma.vue'
import AdminFutureAudits from '../views/admin/futureAudits/AdminFutureAudits.vue'

import AdminUsers from '@/views/admin/users/AdminUsers.vue'
import AdminUsersEdit from '@/views/admin/users/AdminUsersEdit.vue'

import AdminActivities from '@/views/admin/activities/AdminActivities.vue'
import AdminActivitiesEdit from '@/views/admin/activities/AdminActivitiesEdit.vue'

import AdminBlocks from '@/views/admin/blocks/AdminBlocks.vue'
import AdminBlocksEdit from '@/views/admin/blocks/AdminBlocksEdit.vue'

import AdminBranches from '@/views/admin/branches/AdminBranches.vue'

import AdminQuestions from '@/views/admin/questions/AdminQuestions.vue'
import AdminQuestionsEdit from '@/views/admin/questions/AdminQuestionsEdit.vue'

import AdminTodoCategories from '@/views/admin/todoCategories/AdminTodoCategories.vue'
import AdminTodoCategoriesEdit from '@/views/admin/todoCategories/AdminTodoCategoriesEdit.vue'

import AdminStandardBooks from '@/views/admin/standardBooks/AdminStandardBooks.vue'
import AdminStandardBookEdit from '@/views/admin/standardBooks/AdminStandardBookEdit.vue'

import AdminMobileVersions from '@/views/admin/versions/AdminMobileVersions.vue'

import AdminMmlCategories from '@/views/admin/mmlCategories/AdminMmlCategories.vue'
import AdminMmlCategoriesEdit from '@/views/admin/mmlCategories/AdminMmlCategoriesEdit.vue'

import AdminPhotoCategories from '@/views/admin/photoCategories/AdminPhotoCategories.vue'
import AdminPhotoCategoriesEdit from '@/views/admin/photoCategories/AdminPhotoCategoriesEdit.vue'

import AdminTagsStandardsBook from '@/views/admin/tags/standardsBook/AdminTagsStandardsBook.vue'
import AdminTagsStandardsBookEdit from '@/views/admin/tags/standardsBook/AdminTagsStandardsBookEdit.vue'

import AdminTagsActivities from '@/views/admin/tags/activities/AdminTagsActivities.vue'
import AdminTagsActivitiesEdit from '@/views/admin/tags/activities/AdminTagsActivitiesEdit.vue'

import AdminBotFilters from '@/views/admin/bot/filters/AdminBotFilters.vue'
import AdminBotFiltersEdit from '@/views/admin/bot/filters/AdminBotFiltersEdit.vue'

import AdminSubSections from '@/views/admin/subSections/AdminSubSections.vue'

import AdminCache from '@/views/admin/cache/AdminCache.vue'

const ifAdminAuthenticated = (to, from, next) => {

    if (store.getters.isAuthenticated) {
        next()
        return
    }

    next(AllRoutes.Account.Login)
}

export default [
    {
        path: AllRoutes.Admin.FutureAudits.Index,
        component: AdminFutureAudits,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Аудиты +",
            header: "Будущие аудиты"
        },

    },

    {
        path: AllRoutes.Admin.Tma.Index,
        component: AdminTma,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "TMA",
            header: "TMA"
        },

    },

    {
        path: AllRoutes.Admin.Routes.Index,
        component: AdminRoutes,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Просмотр маршрутов",
            header: "Маршруты"
        }
    },

    {
        path: AllRoutes.Admin.Audits.Index,
        component: AdminAudits,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Поиск аудитов",
            header: "Аудиты"
        },

    },

    {
        path: AllRoutes.Admin.Users.Index,
        component: AdminUsers,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список пользователей",
            header: "Пользователи"
        },

    },

    {
        path: AllRoutes.Admin.Users.Edit,
        component: AdminUsersEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение пользователя",
            header: "Пользователи"
        }
    },

    {
        path: AllRoutes.Admin.Activities.Index,
        component: AdminActivities,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список активностей",
            header: "Активности"
        }
    },

    {
        path: AllRoutes.Admin.Activities.Edit,
        component: AdminActivitiesEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение активности",
            header: "Активности"
        }
    },

    {
        path: AllRoutes.Admin.Blocks.Index,
        component: AdminBlocks,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список блоков вопросов",
            header: "Блоки вопросов"
        }
    },

    {
        path: AllRoutes.Admin.Blocks.Edit,
        component: AdminBlocksEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение блока вопроса",
            header: "Блоки вопросов"
        }
    },

    {
        path: AllRoutes.Admin.Branches.Index,
        component: AdminBranches,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список филиалов",
            header: "Филиалы"
        }
    },

    {
        path: AllRoutes.Admin.Questions.Index,
        component: AdminQuestions,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список вопросов",
            header: "Вопросы"
        }
    },

    {
        path: AllRoutes.Admin.Questions.Edit,
        component: AdminQuestionsEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение вопроса",
            header: "Вопросы"
        }
    },

    {
        path: AllRoutes.Admin.TodoCategories.Index,
        component: AdminTodoCategories,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список категорий задач",
            header: "Категории задач"
        }
    },

    {
        path: AllRoutes.Admin.TodoCategories.Edit,
        component: AdminTodoCategoriesEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение категории задачи",
            header: "Категории задач"
        }
    },

    {
        path: AllRoutes.Admin.StandardBooks.Index,
        component: AdminStandardBooks,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список книг стандартов",
            header: "Книга стандартов"
        }
    },

    {
        path: AllRoutes.Admin.StandardBooks.Edit,
        component: AdminStandardBookEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение книги стандартов",
            header: "Книга стандартов"
        }
    },

    {
        path: AllRoutes.Admin.MobileVersions.Index,
        component: AdminMobileVersions,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Версии мобильного приложения",
            header: "Версии"
        }
    },

    {
        path: AllRoutes.Admin.MmlCategories.Index,
        component: AdminMmlCategories,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список категорий MML",
            header: "Категории MML"
        }
    },

    {
        path: AllRoutes.Admin.MmlCategories.Edit,
        component: AdminMmlCategoriesEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение категории MML",
            header: "Категории MML"
        }
    },

    {
        path: AllRoutes.Admin.PhotoCategories.Index,
        component: AdminPhotoCategories,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список категорий фото",
            header: "Категории фото"
        }
    },

    {
        path: AllRoutes.Admin.PhotoCategories.Edit,
        component: AdminPhotoCategoriesEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение категории фото",
            header: "Категории фото"
        }
    },

    {
        path: AllRoutes.Admin.Tags.StandardsBook.Index,
        component: AdminTagsStandardsBook,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список хэштегов",
            header: "Хэштеги"
        }
    },

    {   
        path: AllRoutes.Admin.Tags.StandardsBook.Edit,
        component: AdminTagsStandardsBookEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение тега",
            header: "Хэштеги"
        }
    },

    {
        path: AllRoutes.Admin.Tags.Activities.Index,
        component: AdminTagsActivities,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список хэштегов",
            header: "Хэштеги"
        }
    },

    {   
        path: AllRoutes.Admin.Tags.Activities.Edit,
        component: AdminTagsActivitiesEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение тега",
            header: "Хэштеги"
        }
    },

    {
        path: AllRoutes.Admin.SubSections.Index,
        component: AdminSubSections,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Список подразделов",
            header: "Подразделы"
        }
    },

    {
        path: AllRoutes.Admin.Cache.Index,
        component: AdminCache,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Кэш мобильного API",
            header: "Кэш мобильного API"
        }
    },

    {
        path: AllRoutes.Admin.Bot.Filters.Index,
        component: AdminBotFilters,
        beforeEnter: ifAdminAuthenticated,
        meta: {
          layout: "adminLayout",
          title: "Список фильтров",
          header: "Бот"
        }
    },

    {   
        path: AllRoutes.Admin.Bot.Filters.Edit,
        component: AdminBotFiltersEdit,
        beforeEnter: ifAdminAuthenticated,
        meta: {
            layout: "adminLayout",
            title: "Изменение фильтра",
            header: "Бот"
        }
    }
]